import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatOptionModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from "@angular/router";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { SharedModule } from "../../shared/shared.module";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { IncomeSharedModule } from "../shared/income-shared.module";

import { RecurrentListV2Component } from "./components/recurrent-list/recurrent-list.components";
import { RecurrentFormV2Component } from "./components/recurrent-form/recurrent-form.components";
import { RecurrentService } from "./services/recurrent.service";
import { RecurrentReducer } from "./store/reducers/recurrent.reducer";
import { RecurrentEffects } from "./store/effects/recurrent.effects";

@NgModule({
  declarations: [
    RecurrentListV2Component,
    RecurrentFormV2Component,
  ],
  exports: [
    RecurrentListV2Component,
    RecurrentFormV2Component,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    SharedModule,
    IncomeSharedModule,
    RouterModule,
    FormsModule,

    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,
    MatOptionModule,
    MatDatepickerModule,
    MatCheckboxModule,
    DragDropModule,

    StoreModule.forFeature('recurrent', RecurrentReducer),
    EffectsModule.forFeature([RecurrentEffects]),
  ],
  providers: [
    RecurrentService,
  ]
})
export class RecurrentModule { }
